<template>
  <a-spin :spinning="confirmLoading">
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-row>
        <a-col :span="24">
          <a-form-item label="课程名称">
            <a-input
              placeholder="请输入课程名称"
              :max-length="25"
              v-decorator="[
                'subjectName',
                { rules: [{ required: true, message: '请选择课程名称' }] },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="作者">
            <a-input
              placeholder="请输入作者"
              :max-length="25"
              v-decorator="['author']"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="课程标签">
            <a-input
              placeholder="请输入课程标签"
              :max-length="25"
              v-decorator="['subjectTag']"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="封面图"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="coverPicture"
          >
            <UploadImage
            :imgUrl="model.coverPicture"
            @handleFileList="handleImageList"
            v-decorator="[
                'coverPicture',
                { rules: [{ required: true, message: '请上传封面图' }] },
              ]"
          />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="课程简介"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="subjectIntroduction"
          >
            <tinymce-editor
              ref="tinymceEditor"
              :teid="'articleTinymce'"
              style="width: 500px"
              @change="getMyValue"
              v-model="model.subjectIntroduction"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="渠道栏目"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="columnCode"
          >
            <a-tree-select
              size="large"
              style="width: 500px"
              ref="notice"
              :tree-data="columnChannel"
              @change="onChange"
              placeholder="请选择发布渠道栏目"
              v-decorator="[
                'columnCode',
                { rules: [{ required: true, message: '请选择发布渠道栏目' }] },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24" class="form-footer">
          <a-form-item
            label="发布时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            prop="publishTime"
          >
            <a-date-picker
              size="large"
              style="width: 100%"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              v-decorator="[
                'publishTime',
                { rules: [{ required: true, message: '请选择发布时间' }] },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-spin>
</template>

<script>
import { jsonAction, getAction } from '@/api/manage';
import moment from 'moment';
import UploadImage from '@/components/common/UploadImage';
import tinymceEditor from '@/components/tools/tinymceEditor';
import { findTreeNodeArray } from '@/utils/common';
export default {
  name: 'CmSmSubjectForm',
  components: {
    tinymceEditor,
    UploadImage,
  },
  props: ['columnChannel'],
  data() {
    return {
      form: this.$form.createForm(this),
      model: {
        subjectIntroduction: '',
      },
      imgUrl: '',
      columnId: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/subject/cmSmSubject/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/subject/cmSmSubject/edit',
        queryById:
          process.env.VUE_APP_CMS_CONTENT + '/subject/cmSmSubject/queryById',
      },
      imgFile: {}, //封面
    };
  },
  computed: {
    formDisabled() {
      return this.disabled;
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
  },
  methods: {
    moment,
    handleImageList(file) {
      this.imgFile = file;
       this.model.coverPicture = file.fileUrl;
    },
    getMyValue(val) {
      this.model.subjectIntroduction = val;
    },
    onChange(value, label, val) {
      this.columnId = value;
    },
    add() {
      // this.imgUrl = "";
    },
    edit(record) {
      this.id = record.id;
      let params = {
        id: record.id,
      };
      getAction(this.url.queryById, params).then((res) => {
        if (res.success) {
          let columnVlaue;
          if (res.result.columnCode) {
            columnVlaue = this.getChannelData(res.result.columnCode);
          }
          this.model.coverPicture = res.result.coverPicture;
           this.imgFile.fileUrl = res.result.previewUrl;
          this.imgFile.fileName = res.result.coverPicture;

          this.$nextTick(() => {
            this.model = res.result;
            let data = {
              subjectName: this.model.subjectName,
              author: this.model.author,
              subjectTag: this.model.subjectTag,
              coverPicture: this.model.coverPicture,
              columnCode: this.model.columnCode,
              publishTime: this.model.publishTime,
            };
            data.columnCode = columnVlaue;
            this.form.setFieldsValue(data);
          });
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    close() {
      this.$emit('close');
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        let formData = Object.assign({}, this.model, values);
        formData.coverPicture = this.imgFile.fileName;
        formData = Object.assign(formData, this.handleChannelData());
        formData.publishTime = moment(formData.publishTime).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        if (!err) {
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          jsonAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              this.close();
              that.confirmLoading = false;
            });
        }
      });
    },
    getChannelData(code) {
      let arr = findTreeNodeArray('children', this.columnChannel, (e) => {
        return code == e.code;
      });
      if (arr.length > 0) {
        return arr[0].value;
      }
      return '';
    },
    handleChannelData() {
      let arr = findTreeNodeArray('children', this.columnChannel, (e) => {
        return this.columnId == e.id;
      });
      console.log('arr++++++', arr);
      let obj = arr[0] || {};
      return {
        channelCode: obj.channelCode,
        channelName: obj.channelName,
        columnCode: obj.code,
        columnName: obj.name,
      };
    },
  },
};
</script>
<style lang="less" scoped>
.form-footer {
  padding-bottom: 20px;
}
</style>
